import axios from "axios";
import React, { useState, useEffect } from "react";
import FullscreenIcon from "@mui/icons-material/OpenInFull";
import { Modal, Box, Typography, IconButton, Backdrop } from "@mui/material";
import { Fullscreen } from "@mui/icons-material";

const MejoresResultadosReport = () => {
  const [selectedTable, setSelectedTable] = useState("misResultados");
  const [rankingData, setRankingData] = useState([]);
  const [companyData, setCompanyData] = useState([]);
  const [selectedCompanyData, setSelectedCompanyData] = useState([]);
  const [openModal, setOpenModal] = useState(false);
  const handleOpen = (selectedCompany) => {
    setOpenModal(true);
    setSelectedCompanyData(selectedCompany);
  };
  const handleClose = () => setOpenModal(false);
  const maxVisible = 1;

  useEffect(() => {
    fetchData();
  }, []);

  const baseUrl = process.env.REACT_APP_SERVER_URL;

  const fetchData = async () => {
    const token = localStorage.getItem("auth_token");

    if (!token) {
      console.error("No authentication token found!");
      return;
    }

    const currentYear = new Date().getFullYear();
    const latestYears = [currentYear, currentYear - 1, currentYear - 2];
    const yearParams = latestYears.map((year) => `year=${year}`).join("&");

    const majorResultsURL = `${baseUrl}/api/principal/reports/major_results?${yearParams}`;
    const rankingURL = `${baseUrl}/api/principal/reports/overall_companies_rank`;

    try {
      // Call both APIs in parallel for better performance
      const [majorResultsRes, rankingRes] = await Promise.all([
        axios.get(majorResultsURL, {
          headers: { Authorization: `token ${token}` },
        }),
        axios.get(rankingURL, {
          headers: { Authorization: `token ${token}` },
        }),
      ]);

      console.log("Major Results:", majorResultsRes.data.data);
      console.log("Rankings:", rankingRes.data.data);

      setCompanyData(majorResultsRes?.data?.data);
      setRankingData(rankingRes?.data?.data);
    } catch (error) {
      console.error(" Error fetching data:", error);
    }
  };

  return (
    <>
      <div style={{ paddingTop: "20px", fontFamily: "Arial, sans-serif" }}>
        {/* Header - Toggle Results */}
        <div
          style={{
            display: "flex",
            alignItems: "center",
            marginBottom: "15px",
          }}
        >
          <span style={{ marginRight: "10px", fontWeight: "bold" }}>Ver:</span>
          <label
            style={{
              marginRight: "20px",
              display: "flex",
              alignItems: "center",
            }}
          >
            <input
              type="radio"
              name="results"
              value="misResultados"
              checked={selectedTable === "misResultados"}
              onChange={() => setSelectedTable("misResultados")}
            />
            <span style={{ marginLeft: "5px" }}>Mis resultados</span>
          </label>
          <label style={{ display: "flex", alignItems: "center" }}>
            <input
              type="radio"
              name="results"
              value="mejoresResultados"
              checked={selectedTable === "mejoresResultados"}
              onChange={() => setSelectedTable("mejoresResultados")}
            />
            <span style={{ marginLeft: "5px" }}>Mejores resultados ANDA</span>
          </label>
        </div>

        {/* Show My Results Table */}
        {selectedTable === "misResultados" && (
          <table
            style={{
              width: "100%",
              borderCollapse: "collapse",
              marginBottom: "20px",
            }}
          >
            <thead>
              <tr
                style={{
                  borderBottom: "2px solid #ddd",
                }}
              >
                <th
                  style={{
                    ...tableHeaderStyle,
                    paddingRight: "40px",
                    width: "40%",
                  }}
                >
                  Capítulos
                </th>
                <th style={{ ...tableHeaderStyle }}>2023</th>
                <th style={{ ...tableHeaderStyle }}>2024</th>
                <th style={{ ...tableHeaderStyle }}>2025</th>
                <th style={tableHeaderStyle}>Mejor resultado</th>
              </tr>
            </thead>
            <tbody>
              {companyData?.length === 0 ? (
                <tr>
                  <td colSpan="5" style={tableCellStyle}>
                    Cargando datos...
                  </td>
                </tr>
              ) : (
                companyData?.map((item, index) => (
                  <tr key={index} style={{ borderBottom: "1px solid #ddd" }}>
                    <td style={{ ...tableCellStyle, ...dividerStyle }}>
                      <div style={{ display: "flex", alignItems: "center" }}>
                        <img
                          src={item.icon}
                          alt="icon"
                          style={{
                            width: "20px",
                            height: "20px",
                            objectFit: "contain",
                            marginRight: "8px",
                          }}
                        />
                        <strong>{item.title}</strong>
                      </div>
                    </td>

                    {["2023", "2024", "2025"].map((year) => (
                      <td key={year} style={tableCellStyle}>
                        {item.results?.[year]?.weight_result !== undefined
                          ? Math.floor(item.results[year].weight_result)
                          : "—"}
                        %
                      </td>
                    ))}

                    <td style={tableCellStyle}>
                      <div
                        style={{
                          display: "flex",
                          alignItems: "center",
                          justifyContent: "center",
                          gap: "8px",
                        }}
                      >
                        <div style={circleStyle}>
                          {item.best_year
                            ? Math.floor(
                                Object.values(item.best_year)[0].weight_result
                              )
                            : "—"}
                        </div>
                        <span style={{ fontSize: "0.85rem", color: "#888" }}>
                          {item.best_year
                            ? `(${Object.keys(item.best_year)[0]})`
                            : ""}
                        </span>
                      </div>
                    </td>
                  </tr>
                ))
              )}
            </tbody>
          </table>
        )}

        {/* Show Best Results Table */}
        {selectedTable === "mejoresResultados" && (
          <table style={{ width: "100%", borderCollapse: "collapse" }}>
            <thead>
              <tr
                style={{
                  borderBottom: "2px solid #ddd",
                }}
              >
                <th style={{ ...tableHeaderStyle, width: "40%" }}>Capítulos</th>
                <th style={tableHeaderStyle}>Marcos</th>
              </tr>
            </thead>
            <tbody>
              {rankingData?.length === 0 ? (
                <tr>
                  <td colSpan="2" style={tableCellStyle}>
                    Cargando datos...
                  </td>
                </tr>
              ) : (
                rankingData?.map((item, index) => (
                  <tr key={index} style={{ borderBottom: "1px solid #ddd" }}>
                    <td style={{ ...tableCellStyle, ...dividerStyle }}>
                      <div style={{ display: "flex", alignItems: "center" }}>
                        <img
                          src={item.icon}
                          alt="icon"
                          style={{ width: "20px", marginRight: "8px" }}
                        />
                        <div>
                          <strong>{item.title}</strong>
                        </div>
                      </div>
                    </td>

                    <td style={{ ...tableCellStyle }}>
                      <div
                        style={{
                          display: "flex",
                          justifyContent: "space-between",
                          alignItems: "center",
                          flexWrap: "wrap",
                        }}
                      >
                        <div>
                          {item.results?.top_companies
                            ?.slice(0, maxVisible)
                            .map((company, idx) => (
                              <div
                                style={{
                                  display: "flex",
                                  alignItems: "center",
                                  justifyContent: "space-between",
                                  gap: "8px",
                                  flexWrap: "wrap",
                                }}
                              >
                                {(item.results?.top_companies || [])
                                  .slice(0, 5)
                                  .map((company, idx) => (
                                    <img
                                      key={idx}
                                      src={company?.company?.company_logo}
                                      alt={company?.company?.name}
                                      title={company?.company?.name}
                                      style={{
                                        // width: "56px",
                                        height: "56px",
                                        // objectFit: "contain",
                                        // borderRadius: "50%",
                                        // border: "1px solid #eee",
                                      }}
                                    />
                                  ))}
                              </div>
                            ))}
                        </div>
                        <div>
                          {item.results?.top_companies?.length > 5 && (
                            <IconButton
                              onClick={() =>
                                handleOpen(item.results.top_companies)
                              }
                            >
                              <Fullscreen fontSize="small" />
                            </IconButton>
                          )}
                        </div>
                      </div>
                    </td>
                  </tr>
                ))
              )}
            </tbody>
          </table>
        )}
      </div>
      <>
        {" "}
        {openModal && (
          <Modal
            open={openModal}
            onClose={handleClose}
            aria-labelledby="modal-modal-title"
            aria-describedby="modal-modal-description"
          >
            <Box
              sx={{
                position: "absolute",
                top: "50%",
                left: "50%",
                transform: "translate(-50%, -50%)",
                bgcolor: "background.paper",
                borderRadius: 2,
                boxShadow: 6,
                p: 3,
                minWidth: 500,
                maxWidth: 600,
              }}
            >
              <Typography
                id="modal-modal-title"
                variant="h5"
                component="h3"
                style={{
                  marginBottom: "20%",
                  borderBottom: "2px solid #ddd",
                  paddingBottom: "20px",
                }}
              >
                Empresas Destacadas
              </Typography>{" "}
              <Box sx={{ display: "flex", flexWrap: "wrap", gap: 2 }}>
                {selectedCompanyData?.map((item, index) => (
                  <div key={index} style={{ borderBottom: "1px solid #ddd" }}>
                    <div>
                      <div
                        style={{
                          display: "flex",
                          alignItems: "center",
                          gap: "8px",
                          flexWrap: "wrap",
                        }}
                      >
                        <img
                          src={item?.company?.company_logo}
                          alt={item?.company?.name}
                          title={item?.company?.name}
                          style={{
                            // width: "56px",
                            height: "56px",
                            // objectFit: "contain",
                            // borderRadius: "50%",
                            border: "1px solid #eee",
                          }}
                        />
                      </div>
                    </div>
                  </div>
                ))}
              </Box>
            </Box>
          </Modal>
        )}
      </>
    </>
  );
};

// Table styles
const tableHeaderStyle = {
  padding: "10px ",
  textAlign: "center",
  fontWeight: "bold",
  marginRight: "20px",
};
const modalStyle = {
  position: "absolute",
  top: "50%",
  left: "50%",
  transform: "translate(-50%, -50%)",
  width: 400,
  bgcolor: "background.paper",
  border: "2px solid #000",
  boxShadow: 24,
  p: 4,
};
const tableCellStyle = {
  padding: "10px 8px",
  verticalAlign: "middle",
  textAlign: "center",
};
const circleStyle = {
  display: "flex",
  justifyContent: "center",
  alignItems: "center",
  width: "35px",
  height: "35px",
  borderRadius: "50%",
  border: "2px solid #ddd",
  fontWeight: "bold",
  color: "#0056b3",
  fontSize: "14px",
};

const dividerStyle = {
  borderRight: "2px solid #ddd",
  padding: "12px",
  textAlign: "left",
};

export default MejoresResultadosReport;
